<template>
  <div class="container">
    <div class="row width_full">
      <div class="col_12">
        <div class="customer_content">
          <div class="common_subtitle pb_20">
            <h3 class="mb_0">{{ gallery ? gallery.name : ''}}</h3>
            <router-link :to="{name:'gallery'}" class="btn btn_success" style="float: right">back to gallery list</router-link>
          </div>
          <div class="row">
            <div class="col_12">
              <table v-if="gallery" class="table table_bordered">
                <tbody>
                <tr>
                  <td >Gallery Name:</td>
                  <td>{{ gallery.name }}</td>
                </tr>
                <tr>
                  <td >Gallery Slug:</td>
                  <td>{{ gallery.slug }}</td>
                </tr>
                <tr>
                  <td >Gallery Description:</td>
                  <td>{{ gallery.description }}</td>
                </tr>
                <tr>
                  <td >Gallery Images:</td>
                  <td>{{ images ? images.length : 0 }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col_12">
              <div class="common_subtitle pb_20 mt_20 width_full">
                <h3 class="mb_0">Images</h3>
                <button class="btn btn_success" style="float: right" @click="addNewSlider">Add Image</button>
              </div>
              <div v-if="images && images.length">
                <draggable
                    class="Item_sort"
                    tag="ul"
                    :list="images"
                    :group="{ name: 'g1' }"
                    item-key="name"
                    @sort="sortBanner(images)"
                >
                  <template #item="{element}">
                    <li>
                      <div class="slider_item p_relative">
                        <a :href="element.image" target="_blank" class="width_full">
                          <img :src="element.thumbs ? element.thumbs : '/assets/media/images/no-image.png'" alt="" class="banner_item">
                        </a>
                        <div class="banner_edit p_absolute">
                          <div class="cross_ic" @click.prevent="deleteFileSlider(element.id)">
                            <i class='bx bx-x'></i>
                          </div>
                        </div>
                      </div>
                    </li>
                  </template>
                </draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <modal-component
      v-if="showModal"
      :modal-size="'custom_modal_800p'"
      :header-classes="'display_table white_bg no_border pa15 pb_0'"
      :content-classes="'pl_15 pr_15'"
      @closeModal="closeModal"
  >
    <template #header>
      <span class="modal_header_title">Add Banner</span>
    </template>
    <template #content>
      <div class="row">
        <div class="col_12">
          <div :class="['form-group', {'has_error': errorFor('title')}]">
            <label>name</label>
            <input type="text" class="form_global" placeholder="Title" v-model="form.title">
            <template v-if="errors && errors.title">
              <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.title" :key="'error_status_'+errorIndex">{{error}}</small>
            </template>
          </div>

          <div :class="['form-group', {'has_error': errorFor('image')}]">
            <label>Image</label>
            <input type="file" class="form_global" ref="imageInput" accept="image/*" @input="onFileChange($event)">
            <template v-if="errors && errors.image">
              <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.image" :key="'error_status_'+errorIndex">{{error}}</small>
            </template>
          </div>
          <div class="form-group" v-if="tempImage">
            <div class="cross_ic" @click.prevent="deleteFile">
              <i class='bx bx-x'></i>
            </div>
            <img :src="tempImage" alt=""   width="150">
          </div>

          <div class="d_flex_end">
            <button class="btn btn_common" @click="submit()">Save</button>
          </div>
        </div>


      </div>
    </template>
  </modal-component>
</template>

<script>
import draggable from "vuedraggable"
import ModalComponent from "../../components/shared/ModalComponent";
export default {
  name: "View",
  components: {ModalComponent, draggable},
  data(){
    return {
      gallery: null,
      showModal:false,
      images: [],
      form:{
        title: '',
        gallery_id: '',
        image: '',
      },
      tempImage: '',
    }
  },
  created() {
    this.loadGallery()
  },
  methods:{
    closeModal(){
      this.showModal = false
    },
    onFileChange(event){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;

      let file = event.target.files[0]
      this.form.image = file

      this.tempImage = URL.createObjectURL(file);
    },
    deleteFile(){
      this.tempImage = null
      this.form.image = null
      if(this.$refs.imageInput)
        this.$refs.imageInput.value = null
    },
    resetForm(){
      this.form = {
        title: '',
        gallery_id: this.gallery ? this.gallery.id : '',
        image: '',
      }
      this.newForm = false
      this.deleteFile()
    },
    addNewSlider(){
      this.errors = null;
      this.resetForm()
      this.deleteFile()
      this.newForm = true
      this.showModal = true
    },
    loadGallery(){
      this.axios.get('/galleries/'+this.$route.params.id).then((response) => {
        this.gallery = response.data.data;
        this.form.gallery_id = this.gallery ? this.gallery.id : ''
        this.images = this.gallery.images ? this.gallery.images : []
      })
    },
    sortBanner(ids){
      this.axios.post('/gallery-images/sort', {sliders:ids})
          .then(() => {
            this.loadGallery();
            this.showSuccessMsg("Slider Sorted Successfully!");
          })
    },
    deleteFileSlider(id) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/gallery-images/'+id).then(() => {
            this.$swal.fire(
                'Deleted',
                'Slider has been deleted!',
                'success'
            )
            this.loadGallery();
          });
        }
      });
    },
    submit() {
      this.errors = null;
      this.loading = true;

      let formData = new FormData()

      Object.keys(this.form).forEach(key => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      })

      if (this.newForm) {
        this.axios.post('/gallery-images', formData)
            .then(() => {
              this.showModal = false;
              this.resetForm()
              this.deleteFile()
              this.loadGallery()
              this.showSuccessMsg("Added Successfully!");
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      } else {
        formData.append('_method','PATCH')

        this.axios.post('/gallery-images/'+ this.form.id, formData)
            .then(() => {
              this.showModal = false;
              this.deleteFile()
              this.loadGallery()
              this.showSuccessMsg("Updated Successfully!");
              this.resetForm()
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      }

    },
  }
}
</script>
<style scoped>
.cross_ic{
  position: absolute;
  z-index: 1;
  background: black;
  padding: 2px 2px 0px 2px;
  cursor: pointer;
  color: #fff;
}
.Item_sort{
  display: flex;
  width: 100%;
}
.Item_sort li{
  margin-right: 15px;
  width: 20%;
}
.Item_sort img{
  width: 100%;
  max-height: 180px;
}
.Item_sort video{
  width: 100%;
}
.Item_sort .slider_item{
  width: 100%;
  display: flex;
}
</style>